"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBanFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M4.358 5.557l14.085 14.085A9.956 9.956 0 0112 22C6.486 22 2 17.514 2 12c0-2.453.887-4.702 2.358-6.443zm1.436-1.393A9.952 9.952 0 0112 2c5.514 0 10 4.486 10 10 0 2.343-.81 4.5-2.164 6.206L5.794 4.164z' }))); };
exports.default = SvgBanFilled;
//# sourceMappingURL=BanFilled.js.map